import type React from 'react';
import { useCallback } from 'react';

import { JsonSchemaInput } from '@ragu-components/json-schema-input';
import { OrdFormList, OrdIconStandard, OrdSimpleForm } from '@ragu-components/ord-components';
import { PersonalAccessTokenCreateFields, dataSchema } from '@ragu-components/ord-types';
import { DateInput } from '@ratto-components/ra-form-layout';
import { DateTime } from 'luxon';
import { SelectArrayInput } from 'react-admin';

import type { OrdSimpleFormProps } from '@ragu-components/ord-components';
import type { SelectInputChoiceType } from 'src/lib/types';

export const PersonalAccessTokensForm = (props: OrdSimpleFormProps): React.ReactElement => {
  const scopes: SelectInputChoiceType[] = [
    { id: 'api', name: 'resources.me/personal_access_tokens.scopes.api' },
    { id: 'read_api', name: 'resources.me/personal_access_tokens.scopes.read_api' },
  ];

  const parse = useCallback((date: Date) => DateTime.fromJSDate(date).toFormat('yyyy-MM-dd'), []);

  return (
    <OrdSimpleForm sanitizeFields jsonSchema={dataSchema.PersonalAccessTokenCreate} {...props}>
      <OrdFormList icon={<OrdIconStandard name='token' />}>
        <JsonSchemaInput source={PersonalAccessTokenCreateFields.name} />
        <SelectArrayInput
          choices={scopes}
          source={PersonalAccessTokenCreateFields.scopes}
          variant='outlined'
          isRequired
        />
        <DateInput source={PersonalAccessTokenCreateFields.expires_at} isRequired variant='outlined' parse={parse} />
      </OrdFormList>
    </OrdSimpleForm>
  );
};
